/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const FAQ_VIDEO = require("./res/images/faq_video.mp4");

export const VIDEOS = {
  faq_video: FAQ_VIDEO,
};
